import type NonEmptyText from './non-empty-text';
import type PositiveInteger from './positive-integer';
import type Price from './price';
import { assertIsInstanceOfNonEmptyTextOrNull, assertIsInstanceOfPositiveInteger, assertIsInstanceOfPrice, assertIsPositionOrNull } from './assertions';
import NonNegativeNumber from './non-negative-number';

export interface IPosition extends IPositionInit {
	readonly listPriceTotal: NonNegativeNumber;
	readonly salesPriceTotal: NonNegativeNumber;
}

export interface IPositionInit {
	readonly description: NonEmptyText | null;
	readonly index: PositiveInteger;
	readonly litra: NonEmptyText | null;
	readonly note: NonEmptyText | null;
	readonly parent: null | Position;
	readonly price: Price;
	readonly quantity: PositiveInteger;
}

export default class Position implements IPosition {
	public get description(): NonEmptyText | null {
		return this.#description;
	}

	public get index(): PositiveInteger {
		return this.#index;
	}

	public get listPriceTotal(): NonNegativeNumber {
		return new NonNegativeNumber(this.#quantity.value * this.price.listPrice.value);
	}

	public get litra(): NonEmptyText | null {
		return this.#litra;
	}

	public get note(): NonEmptyText | null {
		return this.#note;
	}

	public get parent(): null | Position {
		return this.#parent;
	}

	public get price(): Price {
		return this.#price;
	}

	public get quantity(): PositiveInteger {
		return this.#quantity;
	}

	public get salesPriceTotal(): NonNegativeNumber {
		return new NonNegativeNumber(this.#quantity.value * this.price.salesPrice.value);
	}

	#description: NonEmptyText | null;
	#index: PositiveInteger;
	#litra: NonEmptyText | null;
	#note: NonEmptyText | null;
	#parent: null | Position;
	#price: Price;
	#quantity: PositiveInteger;

	public constructor({ description, index, litra, note, parent, price, quantity }: IPositionInit) {
		assertIsInstanceOfNonEmptyTextOrNull(description);
		this.#description = description;
		assertIsInstanceOfPositiveInteger(index);
		this.#index = index;
		assertIsInstanceOfNonEmptyTextOrNull(litra);
		this.#litra = litra;
		assertIsInstanceOfNonEmptyTextOrNull(note);
		this.#note = note;
		assertIsPositionOrNull(parent);
		this.#parent = parent;
		assertIsInstanceOfPrice(price);
		this.#price = price;
		assertIsInstanceOfPositiveInteger(quantity);
		this.#quantity = quantity;
	}
}
